const mutations = {
  recievePayments (state, payments) {
    state.payments = payments
  }
}

export default mutations
